import dayjs from 'dayjs';

import { MonthDateFormat, MonthDateYearFormat } from '@/constants/formats';

export const getPeriodTime = (startDate?: string, endDate?: string): string =>
  `${dayjs(startDate).format(MonthDateFormat)} - ${dayjs(endDate).format(MonthDateYearFormat)}`;
